import { useEffect, useState } from 'react';

/**
 * Hook que aplica debounce em valores, esperando um determinado tempo antes de atualizar o valor
 * @param value valor a ser observado
 * @param delay tempo em milissegundos para aguardar antes de atualizar o valor (padrão: 500ms)
 * @returns valor após o delay de debounce
 */
export function useDebounce<T>(value: T, delay = 500): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value);

    useEffect(() => {
        // Configura o timer para atualizar o valor após o delay
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        // Limpa o timer ao mudar o valor ou desmontar o componente
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}
